import styled from 'styled-components';
import { media } from '@shared/styles';

export const StyledBackButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 10px 20px;
  background: ${({ theme }) => theme.colors.surface};
  border: 1.5px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.sizes.borderRadiusSmall};
  color: ${({ theme }) => theme.colors.primary};
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;
  transition: all ${({ theme }) => theme.transitions.default};
  font-family: ${({ theme }) => theme.fonts.primary};
  -webkit-tap-highlight-color: transparent;
  min-height: 44px;

  &:hover {
    background: ${({ theme }) => theme.colors.primaryLight};
    border-color: ${({ theme }) => theme.colors.borderHover};
    box-shadow: 0 4px 12px ${({ theme }) => theme.colors.shadow};
  }

  ${media.tablet} {
    padding: 10px 16px;
    font-size: 0.9rem;
  }
`;
